import { combineReducers } from 'redux';
import uploadReducer from './uploadReducer';
import toggleReducer from './toggleReducer';
import templateReducer from './templateReducer';
import textReducer from './textReducer';

// collect vocabularies from uploadReducer
const rootReducer = combineReducers({
  ShowImitation: toggleReducer,
  Vocabularies: uploadReducer,
  TemplatesSelected: templateReducer,
  Text: textReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js